// extracted by mini-css-extract-plugin
module.exports = {"container":"getintouch_container__2YwCK","content":"getintouch_content__2OQfh","logo":"getintouch_logo__1m1g0","links":"getintouch_links__26A53"};